export enum SelectTypeEnum {
  agent = 'agent',
  bank_account = 'bank_account',
  bonus_period = 'bonus_period',
  cash_account = 'cash_account',
  customer = 'customer',
  operator = 'operator',
  sales = 'sales',
  lead = 'lead',
  admin = 'admin',
  document_admin = 'document_admin',
  employee = 'employee',
  employee_id = 'employee_id',
  guest = 'guest',
  type = 'type',
}
